import { render, staticRenderFns } from "./dataSummary.vue?vue&type=template&id=1ba72ca5&scoped=true&"
import script from "./dataSummary.vue?vue&type=script&lang=js&"
export * from "./dataSummary.vue?vue&type=script&lang=js&"
import style0 from "./dataSummary.vue?vue&type=style&index=0&id=1ba72ca5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba72ca5",
  null
  
)

export default component.exports